// Domains

// Components
import Button, { BUTTON_SIZE, BUTTON_TYPES } from '../../button'

// Styles
import { PDPProductSizeGuide } from '../../sizeGuide/SizeGuide.types'
import styles from '../sizeChart.module.scss'

interface SizeChartMergedSizeChartTabsProps {
  pdpProductSizeGuides: PDPProductSizeGuide[]
  activePdpProductSizeGuide: string
  handlePdpProductSizeGuideChange: (tabName: string) => void
}

const SizeChartMergedSizeChartTabs = (props: SizeChartMergedSizeChartTabsProps) => {
  return (
    <div className={styles.container__tabButtonContainer}>
      {props.pdpProductSizeGuides.map(msc => {
        return (
          <Button
            type={props.activePdpProductSizeGuide === msc.tabName ? BUTTON_TYPES.PRIMARY : BUTTON_TYPES.INACTIVE}
            size={BUTTON_SIZE.MEDIUM}
            className={styles.container__tabButton}
            onClick={() => {
              props.handlePdpProductSizeGuideChange(msc.tabName)
            }}
            key={msc.tabName}
          >
            {msc.tabName}
          </Button>
        )
      })}
    </div>
  )
}

export default SizeChartMergedSizeChartTabs
